import axios from 'axios';
import { getAuthToken, logoutSession } from '../utils/authStorage';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:7993';

const PUBLIC_PATHS = [
  '/login',
  '/sendpasswordlink',
];

const isPublicRequest = (url = '') => PUBLIC_PATHS.some((path) => url.includes(path))
  || url.includes('/ResetPasswordpage/')
  || url.includes('/Changepassword/');

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
});

api.interceptors.request.use((config) => {
  if (!isPublicRequest(config.url)) {
    const token = getAuthToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !isPublicRequest(error.config?.url)) {
      logoutSession();
    }

    if (error.response) {
      const msg = error.response.data?.msg || error.response.data?.message;
      if (msg) {
        const err = new Error(msg);
        err.status = error.response.status;
        err.data = error.response.data;
        return Promise.reject(err);
      }
      return Promise.reject(error);
    }
    return Promise.reject(new Error('Unable to connect to server. Please check if the backend is running on port 7993.'));
  }
);

export { API_BASE_URL };
export default api;
